import {
  InventoryFlow,
  CampaignFormData,
  AdgroupFormData,
  VideoDownloadStatus,
  REGION_ID,
  AdgroupConfig
} from '@tt4b/ttam-enums';
import { useStdAdgroupIs } from '@tt4b/ttam-hooks';
import { computed, Ref } from '@vue/composition-api';
import { i18n } from './../../../i18n';

export function useSwitchPropsDisabled(props: {
  adgroupData: Ref<AdgroupFormData>;
  adgroupConfig: Ref<AdgroupConfig>;
}) {
  const { adgroupData, adgroupConfig } = props;

  const isOnlySelectJapan = computed(
    () => adgroupData.value?.country.includes?.(REGION_ID.JAPAN) && adgroupData.value?.country?.length === 1
  );

  const disabled = computed(() => adgroupConfig.value?.disableVideoDownload || isOnlySelectJapan.value);
  return {
    disabled,
    isOnlySelectJapan,
  };
}

export function useSwitchPropsVisible(props: {
  adgroupData: Ref<AdgroupFormData>;
  campaignData: Ref<CampaignFormData>;
}) {
  const { hasInventoryFlow } = useStdAdgroupIs({
    campaignFormData: props.campaignData,
    adgroupFormData: props.adgroupData,
  });

  return {
    visible: computed(() => hasInventoryFlow(InventoryFlow.TIKTOK)),
  };
}

export function useSwitchHintPropsTips(props: { adgroupData: Ref<AdgroupFormData> }) {
  const tips = computed(() =>
    (props?.adgroupData?.value?.adDownloadStatus === VideoDownloadStatus.ENABLE ?
      i18n.t('module_adgroup_video_download_avaliable') :
      i18n.t('module_adgroup_video_download_disable'))
  );

  return {
    tips,
  };
}
